/**
 * Resolves the organizer sentinel on a plan-seeded email composition into a
 * concrete From value.
 *
 * ScheduleInterview filters the `organizer` sentinel out of the From picker,
 * so any plan defaulting to it has to be swapped before the step can save.
 * The scheduler themselves is the sender when their mailbox is connected —
 * i.e. when they're in the delegatable list `fromOptions` is built from.
 *
 * When it isn't, From is left EMPTY rather than seeded with whichever
 * teammate happens to sort first: sending as an arbitrary colleague is a
 * worse outcome than an empty required field, and the empty value raises the
 * existing "From is required" error so the recruiter picks a sender on
 * purpose.
 */
import type { EmailCompositionValue } from '@kula-ai/components';
import { INTERVIEW_EMAIL_SENDER_ORGANIZER_VALUE } from '../../../InterviewActivity/communication/types';
import { patchEmailComposition } from '../../../InterviewActivity/communication/helpers/emailUtils';

/**
 * `null` when nothing needs changing, so callers can skip the dispatch.
 */
export function seedSenderFrom(
  composition: EmailCompositionValue,
  seedValue: string
): EmailCompositionValue | null {
  if (composition.from !== INTERVIEW_EMAIL_SENDER_ORGANIZER_VALUE) return null;
  return patchEmailComposition(composition, { from: seedValue });
}
